import React, { FC } from "react";
import { ArtifactV1SessionPart, ArtifactV1SessionPartKind } from "../../session.types";
import { SessionPartProps } from "../session-part.types";
import { MDSSessionArtifactNoteCreatedV1Part } from "./session-artifact-note-created-v1-part";
import { MDSSessionArtifactNoteUpdatedV1Part } from "./session-artifact-note-updated-v1-part";

type Props = SessionPartProps<ArtifactV1SessionPart>;

export const MDSSessionArtifactV1Part: FC<Props> = ({ part, ...rest }) => {
  switch (part.artifact_kind) {
    case ArtifactV1SessionPartKind.NoteCreatedV1:
      return <MDSSessionArtifactNoteCreatedV1Part {...rest} part={part} />;
    case ArtifactV1SessionPartKind.NoteUpdatedV1:
      return <MDSSessionArtifactNoteUpdatedV1Part {...rest} part={part} />;
    default:
      return null;
  }
};
